import { render, staticRenderFns } from "./ShipmentLinkDashboard.vue?vue&type=template&id=65a221df&scoped=true&"
import script from "./ShipmentLinkDashboard.vue?vue&type=script&lang=js&"
export * from "./ShipmentLinkDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentLinkDashboard.vue?vue&type=style&index=0&id=65a221df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a221df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a221df')) {
      api.createRecord('65a221df', component.options)
    } else {
      api.reload('65a221df', component.options)
    }
    module.hot.accept("./ShipmentLinkDashboard.vue?vue&type=template&id=65a221df&scoped=true&", function () {
      api.rerender('65a221df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/ShipmentLinkDashboard.vue"
export default component.exports